import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ChromeReaderModeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"chrome_reader_mode"}/>
}
